module.exports = __webpack_public_path__ + "static/media/signature.333f2f6c.svg";